import {negate, overSome, reject, createSelector, sortBy} from 'helpers';
import {flatten, filter} from 'store/common';
import {createRestrictedSelector} from 'store/permissions';
import {tags} from 'store/tags';
import {isBlacklisted, sort} from './settings';

export const index = state => state.notes.index;

export const list = createSelector(
  [ index, tags, isBlacklisted, sort, filter, createRestrictedSelector(index, 'notes') ],
  ( index, tags, isBlacklisted, sort, filter, isRestricted ) => {
    let notes = sortBy.apply(null, [ index, ...sort ]);
    notes = reject(notes, overSome(isBlacklisted, isRestricted, negate(filter || Boolean)));
    if (sort.name == 'tags') {
      notes = tags.sort(notes);
    }
    return flatten(notes);
  }
);
